<button
  class="row-button"
  [class.selected-row-button]="isSelected"
  [class.task-item-variable-bg]="!newTask"
  (click)="onMainButtonClick()"
>
  <button
    class="selector-button day-week-value-button"
    [matMenuTriggerFor]="dropdownOneOptions?.length > 1 ? dropdown1Menu : null"
  >
    {{ dropdownOneControl?.value || '1' }}
  </button>
  <mat-menu #dropdown1Menu="matMenu" class="oph-select-menu">
    @for (option of dropdownOneOptions; track option) {
      <button class="oph-select-menu-item text" (click)="onDropdown1Change(option)">
        {{ option }}
      </button>
    }
  </mat-menu>
  <div class="button-divider" [class.selected-button-divider]="isSelected"></div>
  <button
    class="selector-button day-week-type-button"
    [matMenuTriggerFor]="dropdownTwoOptions?.length > 1 ? dropdown2Menu : null"
  >
    {{ dropdownTwoControl?.value | titlecase }}
    <img src="assets/img/icons/chevron-down-brown.svg" />
  </button>
  <mat-menu #dropdown2Menu="matMenu" class="oph-select-menu">
    @for (option of dropdownTwoOptions; track option) {
      <button class="oph-select-menu-item" (click)="onDropdown2Change(option)">
        <span>{{ option | titlecase }}</span>
      </button>
    }
  </mat-menu>
</button>
